import { render, staticRenderFns } from "./ResponsiblePayRollForSignWidget.vue?vue&type=template&id=16f165e8&scoped=true&"
import script from "./ResponsiblePayRollForSignWidget.vue?vue&type=script&lang=js&"
export * from "./ResponsiblePayRollForSignWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f165e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f165e8')) {
      api.createRecord('16f165e8', component.options)
    } else {
      api.reload('16f165e8', component.options)
    }
    module.hot.accept("./ResponsiblePayRollForSignWidget.vue?vue&type=template&id=16f165e8&scoped=true&", function () {
      api.rerender('16f165e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/widgets/ResponsiblePayRollForSignWidget.vue"
export default component.exports